export default "__VITE_ASSET__DeBuAjf4__"